import { getChainId, } from "wagmi/actions";
import { wagmiConfig as config, } from "@wagmiconfig";
import { getExplorerLink, getTokenDefinition, } from "@bracket/chainography";

import type { AmountString, BlockHash, TokenIdentifier, } from "@bracket/types";
import type { Notification } from "@bracket/ui";
import type { BrktTransaction } from "@bracket/prisma";




/**
 * Creates a success notification for a successful claim transaction
 * 
 * @param {BrktTransaction} txn - The transaction details
 * @param {BlockHash} hash - The transaction hash
 * @returns {Omit<Notification, "id">} A notification object without an ID
 */
export const investSuccessNotification = (
	token: TokenIdentifier,
  amount: AmountString,
	hash: BlockHash,
): Omit<Notification, "id"> => {
	const tok = getTokenDefinition(token);
	return {
		title: "Investment successful",
		message: `you successfully invested ${amount} ${tok.symbol} to the vault`,
		type: "success",
		status: "success",
		primaryAction: {
			label: "View on explorer",
			onClick: () => {
				window.open(getExplorerLink(hash, getChainId(config)), "_blank");
			},
		},
	}
}